import "./bootstrap";

import React, { Component } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import WebFont from "webfontloader";
import ReactGA from "react-ga";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import { persistor, store } from "./src/redux/store";

import Routes from "./src/routes";
import ScrollToTop from "./src/routes/ScrollToTop";
import config from "./src/constants/config";

import * as Sentry from "@sentry/react";

// Import Fonts
WebFont.load({
    custom: {
        families: ["brown", "judge"],
        urls: ["/fonts/index.css"],
    },
});

Sentry.init({
    dsn: "https://9eade52d43f1aa040516cdd831c35cfb@o324581.ingest.sentry.io/4506791524302848",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

if (config.ANALYTICS_ID) {
    // Import Analytics
    ReactGA.initialize(config.ANALYTICS_ID, {
        debug: config.DEV,
        testMode: config.DEV,
    });
}

class Root extends Component {
    render() {
        return (
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <BrowserRouter>
                        <ScrollToTop />
                        <Routes />
                    </BrowserRouter>
                </PersistGate>
            </Provider>
        );
    }
}

ReactDOM.render(<Root />, document.getElementById("app"));
